<template>
    <div class="page">
        <el-row :gutter="4" class="h100">
            <el-col :span="showList ? 4 : 1" :class="['p_r h100i', showList ? '' : 'el-col-unfold']">
                <div :class="['unfoldClassifyBtn', showList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
                     @click="showList = !showList"></div>
                <el-tree class="h100 p_all1 elTree" ref="tree" :data="treeData" :props="defaultProps" v-loading="treeLoading"
                         :highlight-current="highlight" @node-click="selDepartment" v-show="showList" node-key="id"
                         :default-expanded-keys="expandedKeys">
                    <div slot-scope="{ node, data }" class="omit">
                        <el-tooltip class="item" effect="dark" :content="node.label" placement="top-start">
                            <div>{{ node.label }}</div>
                        </el-tooltip>
                    </div>
                </el-tree>
            </el-col>
            <el-col :span="showList ? 20 : 24" :class="['h100', showList ? '' : 'el-col-unfold']">
                <div class="el-table-container">
                    <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                             @keyup.enter.native="refreshList(1)" @submit.native.prevent>
                        <el-form-item prop="name" label="输入搜索：">
                            <el-input v-model.trim="searchForm.name" maxlength="50" placeholder="请输入用户名（50字内）"
                                      clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询
                            </el-button>
                            <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
                        </el-form-item>
                        <div class="f_r">
                            <el-button v-if="hasPermission('lessee:multiTenantList:del')" type="danger" size="small"
                                       icon="el-icon-delete"
                                       @click="del()">批量删除
                            </el-button>
                        </div>
                    </el-form>
                    <el-table
                            :data="dataList"
                            v-loading="loading"
                            @selection-change="selectionChangeHandle"
                            size="small"
                            height="100%"
                            class="table" ref="multipleTable" row-key='id' border>
                        <el-table-column type="selection" :reserve-selection="true">
                        </el-table-column>
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-table class="p_all2"
                                          :data="props.row.list"
                                          size="mini"
                                          max-height="300" ref="expandTable">
                                    <el-table-column prop="tenantName" label="租户名称"
                                                     show-overflow-tooltip></el-table-column>
                                    <el-table-column label="操作" width="200">
                                        <template slot-scope="scope">
                                            <el-button v-if="hasPermission('lessee:multiTenantList:view')" type="text"
                                                       size="small"
                                                       @click="addEdit(props.row.id, scope.row.temporaryAuthorityId, 'view')">
                                                详情
                                            </el-button>
                                            <el-button v-if="hasPermission('lessee:multiTenantList:edit')" type="text"
                                                       size="small"
                                                       @click="addEdit(props.row.id, scope.row.temporaryAuthorityId, 'edit')">
                                                修改
                                            </el-button>
                                            <el-button v-if="hasPermission('lessee:multiTenantList:del')" type="text"
                                                       size="small"
                                                       @click="del(scope.row.temporaryAuthorityId, props.row.id)">删除
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" show-overflow-tooltip label="姓名"></el-table-column>
                        <el-table-column prop="image" label="头像">
                            <template slot-scope="scope">
                                <el-avatar size="small" :src="scope.row.image" style="vertical-align: middle;"></el-avatar>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sex" label="性别">
                            <template slot-scope="scope">
                                {{ scope.row.sex == 2 ? "保密" : (scope.row.sex == 0 ? "男" : "女") }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="mobilePhone" label="手机号" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="logicType" label="启用状态">
                            <template slot-scope="scope">
                                <el-tag size="small" v-if="scope.row.logicType == 0">启用</el-tag>
                                <el-tag size="small" type="danger" v-else>禁用</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="departmentName" label="所属部门" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="tenantName" label="所属租户" show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button v-if="hasPermission('lessee:multiTenantList:add')" type="text" size="small"
                                           @click="addEdit(scope.row.id, null, 'add')">新增租户
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                                @pagination="refreshList"/>
                </div>
            </el-col>
        </el-row>
        <MultiTenantForm ref="multiTenantForm" @refreshDataList="refreshList"></MultiTenantForm>
        <MultiTenantAddForm ref="multiTenantAddForm" @refreshDataList="refreshList"></MultiTenantAddForm>
    </div>
</template>

<script>
    import MultiTenantAddForm from './multiTenantAddForm'
    import MultiTenantForm from './multiTenantForm'

    export default {
        components: {
            MultiTenantForm,
            MultiTenantAddForm,
        },
        data() {
            return {
                showList: true,
                treeData: [],
                treeLoading: false,
                defaultProps: {
                    children: 'children',
                    label: 'departmentName'
                },
                tenantOpt: [],
                searchForm: {
                    name: '',
                    temporaryAuthorityId: '',
                    current: 1,
                    size: 20,
                    department: '',
                    libraryId: '',
                },
                dataList: [],
                total: 0,
                dataListSelections: [],
                loading: false,
                highlight: true,
                expandedKeys: [],
            }
        },
        activated() {
            this.getAllTenant()
            this.searchTree()
        },
        methods: {
            // 获取数据列表
            refreshList(type) {
                if (type == 1) {
                    this.searchForm.current = 1
                }
                if (type == 0) {
                    this.$refs.multipleTable.clearSelection()
                }
                this.loading = true
                this.$axios(this.api.user.queryTenantUserList, this.searchForm, 'post').then(data => {
                    if (data && data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                        this.loading = false
                    }
                })
            },
            // 查询树状数据
            searchTree() {
                this.treeLoading = true
                this.$axios(this.api.user.getDepartmentAll).then(res => {
                    if (res.status) {
                        this.treeData = this.transformData(res.data)
                        if (this.treeData.length) {
                            this.selDepartment(this.treeData[0])
                        }
                    }
                    this.treeLoading = false
                })
            },
            // 树状数据处理
            transformData(data) {
                return data.map(item => {
                    this.$set(item, 'departmentName', item.tenantName)
                    const newItem = {
                        ...item,
                        children: item.sysDepartmentVo
                    };
                    delete newItem.sysDepartmentVo;
                    return newItem;
                });
            },
            // 获取租户名称
            getAllTenant() {
                this.$axios(this.api.user.selectAllTenant).then(res => {
                    if (res.status) {
                        this.tenantOpt = res.data
                    }
                })
            },
            // 选择部门
            selDepartment(val) {
                this.expandedKeys = [val.id]
                // 设置当前选中节点
                this.$nextTick(() => {
                    if (this.$refs.tree) {
                        this.$refs.tree.setCurrentKey(val.id)
                    }
                });
                this.searchForm.temporaryAuthorityId = ''
                this.searchForm.department = ''
                this.searchForm.libraryId = ''
                if (val.departmentType == 1) {
                    this.searchForm.department = val.id || ''
                } else if (val.departmentType == 0) {
                    this.searchForm.libraryId = val.id || ''
                } else {
                    this.searchForm.temporaryAuthorityId = val.id || ''
                }
                this.refreshList(1)
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 新增编辑
            addEdit(userId, temporaryAuthorityId, method) {
                if (method == 'add') {
                    this.$refs.multiTenantAddForm.init(userId)
                } else {
                    this.$refs.multiTenantForm.init(userId, temporaryAuthorityId, method)
                }
            },
            // 删除
            del(id, pId) {
                if (!id && !this.dataListSelections.length) {
                    this.$message.warning('请至少选择一条数据')
                    return
                }
                let api = this.api.user.deleteByTemporaryAuthorityId, p = null, type = 'get'
                if (!id) {
                    api = this.api.user.deleteByUserId
                    type = 'post'
                    p = this.dataListSelections.map(item => {
                        return item.id
                    })
                } else {
                    p = {temporaryAuthorityId: id, userId: pId}
                }
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    this.$axios(api, p, type).then(data => {
                        if (data.status) {
                            this.$message.success('删除成功');
                            this.$refs.multipleTable.clearSelection()
                        } else {
                            this.$message.error(data.msg);
                        }
                        this.refreshList(0);
                        this.loading = false
                    })
                })
            },
            resetSearch() {
                this.$refs.searchForm.resetFields();
                this.$refs.multipleTable.clearSelection()
                this.refreshList(1)
            }
        }
    }
</script>
<style scoped>
    .elTree {
        overflow-y: auto;
    }

    .elTree::-webkit-scrollbar {
        display: none;
    }
</style>
